export const STATUS_LOAN = {
  UNDERWRITING: 2,
  PREFUND: 3,
  DISBURSE: 4,
  PAYMENT: 5,
  ARCHIVE: 6,
  REJECT: 8,
  DRAFT_PRE_APPROVAL: 9,
  PRE_APPROVAL: 10,
  DRAFT_POST_APPROVAL: 11,
  CONFIRM_APPROVAL : 12,
  DECLINE_APPROVAL: 13,
  WAITING_DOCUMENT_APPROVAL : 14,
  WAITING_PRE_APPROVAL : 15,
};

export const STATUS_REASONS = {
  APPROVE: 79,
  REVOKE: 80,
  REUPLOAD: 0,
};

export const LENDER_TYPE = {
  GANESHA: "Ganesha Bank",
};

export const XIGNATURE_STATUS = {
  NOT_REGISTERED: "Not Registered",
  REGISTERED: "Registered",
  DOC_NOT_SIGNED: "Not Signed",
  DOC_COMPLETED: "Completed",
};

export const STATUS_DOC_GANESHA = {
  Credit : "uncollateral_ganesha",
  Invoice : "ganesha_disbursement_receipt"
}

export const SFTP_STATUS = {
  Complete : "Completed",
  Failed : "Failed",
  InProgress : "In Progress"
}

export const PRODUCT_NAME = {
  P2P: "korea p2p",
  G2G: "korea g2g",
  TRAINEE: "trainee loan",
  RO: "daya solusi",
};

export const PRODUCT_IDENTIFIER = {
  TOKUTEI: "tokutei_gino_loan",
  P2P: "korea_p2p",
  G2G: "korea_g2g",
  TRAINEE: "trainee_loan",
  RO: "daya_solusi",
};

export const COLLATERAL_TYPE = {
  SELF: "4e9cd4f9-f908-4e2a-9a3b-ca075dc40b2a",
  OTHER: "1343addc-be0c-43f3-afb5-e21e8987475a",
};

export const DOCUMENT_COLLATERAL_ACTION = {
  UPLOAD: "upload",
  PREVIEW: "preview",
  DOWNLOAD: "download",
};

export const ESCALATE_STATUS = {
  NOT_ESCALATED : 0 ,
  PENDING_CBO : 1 ,
  PENDING_CEO : 2 ,
  APPROVED : 3,
  REJECTED : 4 ,
  RETURNED : 5
}

export const CBO_ESCALATED_ACTION = {
  DRAFT : "cbo_escalated_draft_loan",
  APPROVE : "cbo_escalated_approve_loan",
  RETURN : "cbo_escalated_return_loan",
  REJECT : "cbo_escalated_reject_loan",
}

export const CEO_ESCALATED_ACTION = {
  DRAFT : "ceo_escalated_draft_loan",
  APPROVE : "ceo_escalated_approve_loan",
  RETURN : "ceo_escalated_return_loan",
  REJECT : "ceo_escalated_reject_loan",
}



